import { Customer } from './customer'
import { Note } from './note'
import { Product } from './product'
import { ProductionOrder } from './productionOrder'

export interface OrderListItemModel {
  source: DataSource
  id: string
  createdDateTime?: Date
  vendor: string
  brand?: string
  locale?: string
  channel: string
  channelType?: string
  products: Product[]
  productionOrders: ProductionOrder[]
  paymentHistory?: PaymentHistory[]
  notes?: Note[]
  orderEvents?: OrderEvent[]
  internalOperations?: InternalOperation[]
  shippingAddress?: Address
  billingAddress?: Address
  orderDeliveryAddress?: OrderDeliveryAddress
  customer?: Customer
  status: OrderStatus
  draftOrderStatus?: DraftOrderStatus
  isOldLegacyOrder?: boolean
  price?: Price
  detailedRefundRecords?: DetailedRefundRecord[]
}

//history of refunds
export interface ProductRefund {
  productCode: string
  quantity: number
  productRefundAmount: number
}

export interface DetailedRefundRecord {
  orderCode: string
  reason: string
  refundDate: Date
  status: string
  productRefunds: ProductRefund[]
  shippingCostRefundAmount: number
}

export interface OrderDetails extends OrderListItemModel {
  internalId: string
  invoiceId: string
  customerId?: string
  deliveryInfo?: TraceWithProducts[]
  preselectedProductionOrderId?: string
  preselectedProductId?: string
}

export enum DataSource {
  Unknown = 0,
  Albelli = 1,
  Resnap = 2,
  Studenten = 3,
}

export interface TraceWithProducts {
  distributor?: string
  trackingId?: string
  trackingUrl?: string
  scannedDate?: Date
  estimatedDate?: Date
  products: TraceProduct[]
  deliveryType?: string
  deliveryMethod?: string
  productionOrderId?: string
}

export interface TraceProduct {
  productCode: string
  qty: number
}

export const VendorShopUrls: { [vendorId: string]: string } = {
  '1200': 'https://checkout.ecom.albelli.nl',
  '1201': 'https://checkout.ecom.albelli.de',
  '1203': 'https://checkout.ecom.albelli.fr',
  '1205': 'https://checkout.ecom.albelli.com',
  '1207': 'https://checkout.ecom.albelli.be',
  '1210': 'https://checkout.ecom.albelli.com',
  '1212': 'https://checkout.ecom.albelli.com',
  '1213': 'https://checkout.ecom.onskefoto.se',
  '1214': 'https://checkout.ecom.albelli.com',
  '1215': 'https://checkout.ecom.fotoknudsen.no',
  '1217': 'https://checkout.ecom.monalbumphoto.fr',
  '1221': 'https://checkout.ecom.bonusprint.co.uk',
  '1222': 'https://checkout.ecom.posterxxl.de',
  '1223': 'https://checkout.ecom.posterxxl.at',
  '1224': 'https://checkout.ecom.b2b.posterxxl.de',
  '1225': 'https://checkout.ecom.b2b.posterxxl.de',
  '1226': 'https://checkout.ecom.photobox.co.uk',
  '1227': 'https://checkout.ecom.photobox.fr',
  '1228': 'https://checkout.ecom.photobox.ie',
  '1229': 'https://checkout.ecom.photobox.it',
  '1230': 'https://checkout.ecom.photobox.dk',
  '1231': 'https://checkout.ecom.hofmann.es',
  '1232': 'https://checkout.ecom.hofmann.pt',
}

export interface PaymentHistory {
  received: string
  providerReference?: string
  event?: string
  success?: boolean
  method?: string
  currency?: string
  paidAmount?: number
  reason?: string
}

export interface Price {
  currency?: string
  subTotal?: string
  shipment?: string
  discount?: string
  shippingDiscount?: string
  discountCode?: string
  total?: string
  tax?: string
}

export const ProductOptionNames: { [key: string]: string } = {
  ArticleType: 'Product Type',
  Binding: 'Binding',
  Border: 'Border',
  CoverType: 'Cover',
  CoverText: 'Cover Text',
  Spine: 'Spine',
  PrintSize: 'Print Size',
  PrintSurface: 'Print Surface',
  Glossy: 'Glossy',
  Color: 'Color',
  PhotoSide: 'PhotoSide',
  Material: 'Material',
  PrebuiltPosterFrame: 'PrebuiltPosterFrame',
  PaperType: 'Paper',
  PosterFrame: 'Poster Frame',
  Passepartout: 'Passepartout',
  HangingKit: 'Hanging Kit',
  GiftPackaging: 'Gift Packaging',
  Editor: 'Editor',
  EditorVersion: 'Editor Version',
  BoxFrame: 'BoxFrame',
  FloatingFrame: 'Frame',
  WoodFinishingType: 'Wood Finishing Type',
  PlanksOrientationType: 'Planks Orientation Type',
  WrapperType: 'Wrappers',
  ExtraPages: 'Extra Pages',
  Pages: 'Pages',
  PremiumLayFlat: 'PremiumLayFlat',
  LayFlat: 'LayFlat',
  VoucherDiscount: 'Voucher Discount',
  PrintSize10x10: 'Print Size 10x10',
  PrintSize10x12: 'Print Size 10x12',
  PrintSize10x13: 'Print Size 10x13',
  PrintSize10x15: 'Print Size 10x15',
  PrintSize13x17: 'Print Size 13x17',
  PrintSize13x18: 'Print Size 13x18',
  PrintSize13x19: 'Print Size 13x19',
  PrintSize20x30: 'Print Size 20x30',
  PrintSize13x13: 'Print Size 13x13',
  PrintSize15x20: 'Print Size 15x20',
}

export interface OrderDeliveryAddress {
  customerName?: string
  customerPhone?: string
  companyName?: string
  addressLine1?: string
  addressLine2?: string
  city?: string
  zipCode?: string
  country?: string
  customerTitle?: string
  customerFirstName?: string
  customerPrefix?: string
  customerLastName?: string
  customerEmail?: string
  street?: string
  houseNumber?: string
  houseNumberExtension?: string
  county?: string
  pickupPointId?: string
}

export interface Address {
  type: FulfillmentShipmentDeliveryType
  customerName?: string
  customerPhone?: string
  companyName?: string
  vatNumber?: string
  addressLine1?: string
  addressLine2?: string
  city?: string
  zipCode?: string
  country?: string
  countryId?: string
  customerFirstName?: string
  customerLastName?: string
  firstName?: string
  lastName?: string
  phone?: string
  customerPrefix?: string
  customerTitle?: string
  customerEmail?: string
  email?: string
  plants?: string[]
}

export type FulfillmentShipmentDeliveryType = 0 | 1 | 2

export const FulfillmentShipmentDeliveryTypeNames: { [id: number]: string } = {
  0: 'Unknown',
  1: 'Home',
  2: 'Pickup Point',
}

export interface InternalOperationRequest {
  appVersion: string
  operation: InternalOperationType
  code: string
  vendor: string
  channel: string
  reasonCode?: string
  reasonPhrase?: string
  comment: string
  invoiceId?: string
  source?: DataSource
  products: InternalOperationProduct[]
  productionOrders: InternalOperationProductionOrder[]
}

export interface InternalOperationProduct {
  id: string
  quantity: number
  value: number
}

export interface InternalOperationProductionOrder {
  productionOrderId: string
  products: InternalOperationProduct[]
}

export enum InternalOperationType {
  Unknown = 0,
  Reset = 1,
  Cancel = 2,
  Reupload = 3,
  CancelReupload = 4,
}

export interface InvoiceDownloadRequest {
  superOrderId: string
  vendor: string
  orderNumber: string
  isPaid: boolean
}

export interface OrderEvent {
  id: string
  correlationId?: string
  orderCode: string
  plant: string
  channelType: string
  productCode?: string
  quantity?: number
  status?: string
  productionOrderId?: string
  timestamp: string
  event: string
  comment?: string
  ticketId?: string
  ticketType?: string
  level: OrderEventLevel
  sourceType: OrderEventSourceType
  sourceId?: string
  operator?: string
}

export interface InternalOperation {
  productCode: string
  productionOrderId: string
  reasonCode: string
  comment: string
  timestamp: Date
  operation: string
  causedBy: string
}

export enum OrderStatus {
  Unknown = 0,
  WaitingForPayment = 10,
  WaitingConfirmation = 11,
  WaitingForPaymentConfirmed = 12,
  WaitingForPaymentPending = 13,
  PaymentFailed = 20,
  PaymentSucceeded = 30,
  WaitingForProduction = 40,
  InProduction = 50,
  ScannedForShipment = 60,
  Cancelled = 70,
  OnHold = 80,
  Delivering = 90,
  Delayed = 100,
}

export enum DraftOrderStatus {
  Initial = 'Initial',
  WithAddress = 'WithAddress',
  WithValidAddress = 'WithValidAddress'
}

export enum OrderEvents {
  Delayed = 'delayed',
  Promised = 'promised',
  Unpromised = 'unpromised',
  PromiseBroken = 'promisebroken',
  Reprocess = 'reprocess',
  FullReset = 'bo-FullReset',
  ReuploadPermitted = 'bo-ReUpload',
  CancelReupload = 'bo-CancelReUpload',
  PartialReset = 'bo-PartialReset',
  ReuploadedNew = 'reuploaded-new',
  ReuploadedOriginal = 'reuploaded-old',
  Refund = 'payment-REFUND',
}

export enum OrderEventLevel {
  Unknown,
  Order,
  Product,
  Ticket,
  Debug,
}

export enum OrderEventSourceType {
  Unknown,
  Backoffice,
  Plant,
  StatusProcessor,
  NlhLambdas,
  IntakeProcessor,
  Adyen,
  OrderApi,
  Fritzell, // 3rd party that creates the Studenten products
  FulfillmentIntakeApi,
  ProductContentApi,
  SAPI,
  FulfillmentRequestCreator,
  PdfRetrievalApi,
  Symphony,
  ProductionOrder,
  Mcp,
  DocumentRetrievalApi,
}

export interface Discount {
  id?: string
  definition?: string
  validTo?: string
  validFrom?: string
  description?: string
  usageType?: string
  layer?: string
  status?: string
  tags?: string[]
  createdDate?: string
  lastChangedDate?: string
  singleUseOrderCode?: string
  isOldSystemDiscount: boolean
  removed: boolean
}

export interface ChangeAddressRequest {
  appVersion: string
  orderCode: string
  newAddress: OrderDeliveryAddress
  addressAsString: string
  vendorId: string
}
